const map = {
	"./10k-drive.svg": [
		38329,
		[
			73991
		]
	],
	"./18-plus.svg": [
		91644,
		[
			73991
		]
	],
	"./18plus.svg": [
		10595,
		[
			73991
		]
	],
	"./18plusMrGreen.svg": [
		94935,
		[
			73991
		]
	],
	"./24h.svg": [
		33086,
		[
			73991
		]
	],
	"./888club.svg": [
		36436,
		[
			73991
		]
	],
	"./888club2.svg": [
		62030,
		[
			73991
		]
	],
	"./888wetten.svg": [
		29257,
		[
			73991
		]
	],
	"./AvatarIcon.svg": [
		13628,
		[
			35371
		]
	],
	"./Icon-18.svg": [
		38631,
		[
			73991
		]
	],
	"./Sjalvtest.svg": [
		11514,
		[
			73991
		]
	],
	"./SjalvtestMrGreen.svg": [
		73248,
		[
			73991
		]
	],
	"./Spelgranser.svg": [
		15850,
		[
			73991
		]
	],
	"./SpelgranserMrGreen.svg": [
		464,
		[
			73991
		]
	],
	"./Spelpaus.svg": [
		52875,
		[
			73991
		]
	],
	"./SpelpausMrGreen.svg": [
		62159,
		[
			73991
		]
	],
	"./about-us.svg": [
		7444,
		[
			73991
		]
	],
	"./account-statement.svg": [
		1525,
		[
			73991
		]
	],
	"./account.svg": [
		17653,
		[
			73991
		]
	],
	"./add-user.svg": [
		75535,
		[
			73991
		]
	],
	"./alert.svg": [
		56402,
		[
			73991
		]
	],
	"./app-download.svg": [
		25894,
		[
			73991
		]
	],
	"./az-sports.svg": [
		49087,
		[
			73991
		]
	],
	"./back-btn.svg": [
		84890,
		[
			73991
		]
	],
	"./be-gamble-aware.svg": [
		68169,
		[
			73991
		]
	],
	"./bell.svg": [
		37995,
		[
			73991
		]
	],
	"./bet-feed-old.svg": [
		36966,
		[
			73991
		]
	],
	"./bet-feed.svg": [
		8650,
		[
			73991
		]
	],
	"./betfeed-mrg.svg": [
		82106,
		[
			73991
		]
	],
	"./biometrics-login.svg": [
		26245,
		[
			73991
		]
	],
	"./blog.svg": [
		58756,
		[
			73991
		]
	],
	"./bonuses.svg": [
		46485,
		[
			73991
		]
	],
	"./burger-old.svg": [
		57295,
		[
			73991
		]
	],
	"./burger.svg": [
		51479,
		[
			73991
		]
	],
	"./casino-daily-wish.svg": [
		13123,
		[
			73991
		]
	],
	"./casino-game.svg": [
		69564,
		[
			73991
		]
	],
	"./casino-history.svg": [
		94042,
		[
			73991
		]
	],
	"./casino-mrg.svg": [
		99558,
		[
			73991
		]
	],
	"./casino-si.svg": [
		87870,
		[
			73991
		]
	],
	"./challanges-shield.svg": [
		73424,
		[
			73991
		]
	],
	"./challenges.svg": [
		46866,
		[
			73991
		]
	],
	"./chat.svg": [
		35514,
		[
			73991
		]
	],
	"./check.svg": [
		50240,
		[
			73991
		]
	],
	"./clock.svg": [
		79274,
		[
			73991
		]
	],
	"./close-x.svg": [
		65483,
		[
			73991
		]
	],
	"./close.svg": [
		71084,
		[
			73991
		]
	],
	"./confirmed.svg": [
		87187,
		[
			73991
		]
	],
	"./control-center.svg": [
		63891,
		[
			73991
		]
	],
	"./cool_arrow.svg": [
		99421,
		[
			73991
		]
	],
	"./cross-casino-logo.svg": [
		8492,
		[
			73991
		]
	],
	"./cross-poker-logo.svg": [
		12220,
		[
			73991
		]
	],
	"./cross-sell-casino-mobile.svg": [
		47802,
		[
			73991
		]
	],
	"./cross-sell-casino.svg": [
		44827,
		[
			73991
		]
	],
	"./cross-sell-poker-mobile.svg": [
		51616,
		[
			73991
		]
	],
	"./cross-sell-poker.svg": [
		61253,
		[
			73991
		]
	],
	"./cross-sell-sport-mobile.svg": [
		66783,
		[
			73991
		]
	],
	"./cross-sell-sport.svg": [
		19052,
		[
			73991
		]
	],
	"./cross-sport-logo.svg": [
		14971,
		[
			73991
		]
	],
	"./de-migration-logo.svg": [
		22918,
		[
			73991
		]
	],
	"./default-icon.svg": [
		73587,
		[]
	],
	"./default-logo.svg": [
		58845,
		[
			73991
		]
	],
	"./deposit.svg": [
		85098,
		[
			73991
		]
	],
	"./depositLimit.svg": [
		75575,
		[
			73991
		]
	],
	"./dice.svg": [
		81129,
		[
			73991
		]
	],
	"./disconnect-error.svg": [
		1971,
		[
			73991
		]
	],
	"./disconnect.svg": [
		52270,
		[
			73991
		]
	],
	"./disconnected.svg": [
		95137,
		[
			73991
		]
	],
	"./document-checked.svg": [
		76775,
		[
			73991
		]
	],
	"./document.svg": [
		9387,
		[
			73991
		]
	],
	"./documentWithTimer.svg": [
		49374,
		[
			73991
		]
	],
	"./download-app.svg": [
		710,
		[
			73991
		]
	],
	"./download.svg": [
		73416,
		[
			73991
		]
	],
	"./e-magazine.svg": [
		29600,
		[
			73991
		]
	],
	"./email.svg": [
		9120,
		[
			73991
		]
	],
	"./face-id.svg": [
		22315,
		[
			73991
		]
	],
	"./financial.svg": [
		45117,
		[
			73991
		]
	],
	"./finger-print.svg": [
		42849,
		[
			73991
		]
	],
	"./flag.svg": [
		92982,
		[
			73991
		]
	],
	"./football.svg": [
		25563,
		[
			73991
		]
	],
	"./free-bets.svg": [
		73331,
		[
			73991
		]
	],
	"./free-play.svg": [
		821,
		[
			73991
		]
	],
	"./freespin.svg": [
		70082,
		[
			73991
		]
	],
	"./gam-care.svg": [
		67609,
		[
			73991
		]
	],
	"./game-frame-close.svg": [
		9485,
		[
			73991
		]
	],
	"./game-frame-eighteenplus.svg": [
		42396,
		[
			73991
		]
	],
	"./game-frame-expand.svg": [
		19247,
		[
			73991
		]
	],
	"./game-frame-shrink.svg": [
		24900,
		[
			73991
		]
	],
	"./games.svg": [
		79993,
		[
			73991
		]
	],
	"./gaming.svg": [
		8327,
		[
			73991
		]
	],
	"./gear.svg": [
		51049,
		[
			73991
		]
	],
	"./globe.svg": [
		81503,
		[
			73991
		]
	],
	"./green-gaming.svg": [
		30201,
		[
			73991
		]
	],
	"./help-link.svg": [
		52934,
		[
			73991
		]
	],
	"./help.svg": [
		78601,
		[
			73991
		]
	],
	"./history-new.svg": [
		60549,
		[
			73991
		]
	],
	"./history.svg": [
		28736,
		[
			73991
		]
	],
	"./home-new.svg": [
		84480,
		[
			73991
		]
	],
	"./home.svg": [
		3213,
		[
			73991
		]
	],
	"./hourglass.svg": [
		11958,
		[
			73991
		]
	],
	"./how-to-deposit.svg": [
		53369,
		[
			73991
		]
	],
	"./how-to-play.svg": [
		93735,
		[
			73991
		]
	],
	"./icon-profile.svg": [
		42483,
		[
			73991
		]
	],
	"./info-tip.svg": [
		19956,
		[
			73991
		]
	],
	"./info.svg": [
		51652,
		[
			73991
		]
	],
	"./inplay.svg": [
		93279,
		[
			73991
		]
	],
	"./invite-a-friend.svg": [
		99982,
		[
			73991
		]
	],
	"./leaderboard-new.svg": [
		45880,
		[
			73991
		]
	],
	"./light.svg": [
		98764,
		[
			68228
		]
	],
	"./live-now-side-menu.svg": [
		53045,
		[
			73991
		]
	],
	"./live-old.svg": [
		26914,
		[
			73991
		]
	],
	"./live.svg": [
		19286,
		[
			73991
		]
	],
	"./localization-language.svg": [
		60242,
		[
			73991
		]
	],
	"./localization-pin.svg": [
		33289,
		[
			73991
		]
	],
	"./location-pin.svg": [
		99943,
		[
			73991
		]
	],
	"./location-plugin.svg": [
		10491,
		[
			73991
		]
	],
	"./location-plugin_si.svg": [
		85602,
		[
			73991
		]
	],
	"./location-search-pin.svg": [
		41792,
		[
			73991
		]
	],
	"./locker.svg": [
		74212,
		[
			73991
		]
	],
	"./logo-18-plus.svg": [
		90430,
		[
			73991
		]
	],
	"./logo-DGA-spillemyndigheden.svg": [
		18338,
		[
			73991
		]
	],
	"./logo-SI-desktop-red-white.svg": [
		87899,
		[
			73991
		]
	],
	"./logo-SI-mobile-header-white.svg": [
		63273,
		[
			73991
		]
	],
	"./logo-abon.svg": [
		25760,
		[
			73991
		]
	],
	"./logo-egt.svg": [
		26134,
		[
			73991
		]
	],
	"./logo-mrg-mobile.svg": [
		73925,
		[
			73991
		]
	],
	"./logo-mrg.svg": [
		21894,
		[
			57752
		]
	],
	"./logo-oktocash.svg": [
		67010,
		[
			73991
		]
	],
	"./logo-rofus.svg": [
		66203,
		[
			73991
		]
	],
	"./logo-spil-ansvarligt.svg": [
		32186,
		[
			73991
		]
	],
	"./logo-stop-spillet.svg": [
		69360,
		[
			73991
		]
	],
	"./logout.svg": [
		31834,
		[
			73991
		]
	],
	"./map-circle-vi.svg": [
		88763,
		[
			73991
		]
	],
	"./map-circle.svg": [
		22295,
		[
			73991
		]
	],
	"./map-circle_si.svg": [
		95182,
		[
			73991
		]
	],
	"./menu-spinner.svg": [
		58413,
		[
			73991
		]
	],
	"./migrationro-hours.svg": [
		21295,
		[
			73991
		]
	],
	"./migrationro-oneapp.svg": [
		86783,
		[
			73991
		]
	],
	"./migrationro-tournaments.svg": [
		88002,
		[
			73991
		]
	],
	"./mobile-light.svg": [
		91237,
		[
			73991
		]
	],
	"./moneyWallet.svg": [
		21443,
		[
			73991
		]
	],
	"./more.svg": [
		66691,
		[
			73991
		]
	],
	"./mrgreen-myaccount-area.svg": [
		75252,
		[
			73991
		]
	],
	"./notification.svg": [
		29301,
		[
			73991
		]
	],
	"./odds.svg": [
		96958,
		[
			73991
		]
	],
	"./offers.svg": [
		30901,
		[
			73991
		]
	],
	"./perfect-10.svg": [
		11523,
		[
			73991
		]
	],
	"./plus-cashier-mr-green.svg": [
		89234,
		[
			45847
		]
	],
	"./plus-cashier.svg": [
		59388,
		[
			12990
		]
	],
	"./poker-history.svg": [
		89720,
		[
			73991
		]
	],
	"./poker-mrg.svg": [
		3880,
		[
			73991
		]
	],
	"./poker.svg": [
		48039,
		[
			73991
		]
	],
	"./pokerCards.svg": [
		7868,
		[
			73991
		]
	],
	"./pokerDownloadUser.svg": [
		39658,
		[
			73991
		]
	],
	"./poker_logo.svg": [
		60835,
		[
			73991
		]
	],
	"./poker_logo_mobile.svg": [
		50292,
		[
			73991
		]
	],
	"./popular.svg": [
		74175,
		[
			73991
		]
	],
	"./popupLight.svg": [
		34634,
		[
			90609
		]
	],
	"./promotions-prelogin.svg": [
		67029,
		[
			73991
		]
	],
	"./promotions.svg": [
		41218,
		[
			73991
		]
	],
	"./question-mark.svg": [
		16090,
		[
			73991
		]
	],
	"./real-money-poker.svg": [
		28291,
		[
			73991
		]
	],
	"./recommendations-old.svg": [
		38440,
		[
			73991
		]
	],
	"./recommendations.svg": [
		50768,
		[
			73991
		]
	],
	"./rectangle-poker.svg": [
		96895,
		[
			73991
		]
	],
	"./redeem-gold-token.svg": [
		62499,
		[
			73991
		]
	],
	"./redirect-focus.svg": [
		63907,
		[
			73991
		]
	],
	"./register.svg": [
		56107,
		[
			73991
		]
	],
	"./responsible-gaming.svg": [
		72426,
		[
			73991
		]
	],
	"./result_arrow.svg": [
		59637,
		[
			73991
		]
	],
	"./reverse-withdraw.svg": [
		45225,
		[
			73991
		]
	],
	"./rewards.svg": [
		84244,
		[
			73991
		]
	],
	"./search.svg": [
		13060,
		[
			73991
		]
	],
	"./security.svg": [
		94090,
		[
			73991
		]
	],
	"./session.svg": [
		84868,
		[
			73991
		]
	],
	"./shield.svg": [
		50811,
		[
			73991
		]
	],
	"./special-offers.svg": [
		32023,
		[
			73991
		]
	],
	"./sport-history.svg": [
		8645,
		[
			73991
		]
	],
	"./sport-mrg.svg": [
		9633,
		[
			73991
		]
	],
	"./sport.svg": [
		48142,
		[
			73991
		]
	],
	"./sport_cross_sell.svg": [
		70114,
		[
			73991
		]
	],
	"./sport_logo.svg": [
		62056,
		[
			73991
		]
	],
	"./sport_logo_VIP.svg": [
		63296,
		[
			73991
		]
	],
	"./sport_logo_mobile.svg": [
		6805,
		[
			73991
		]
	],
	"./sportwetten.svg": [
		94247,
		[
			73991
		]
	],
	"./sportwetten_VIP.svg": [
		90939,
		[
			73991
		]
	],
	"./sportwetten_mobile.svg": [
		7624,
		[
			73991
		]
	],
	"./star-empty.svg": [
		97484,
		[
			73991
		]
	],
	"./star.svg": [
		52344,
		[
			73991
		]
	],
	"./starting_soon.svg": [
		2018,
		[
			73991
		]
	],
	"./theme-mode.svg": [
		27505,
		[
			73991
		]
	],
	"./ticket.svg": [
		46444,
		[
			73991
		]
	],
	"./tickets-new.svg": [
		51482,
		[
			73991
		]
	],
	"./title_races.svg": [
		28709,
		[
			73991
		]
	],
	"./touch-id.svg": [
		56441,
		[
			73991
		]
	],
	"./tournament-tickets.svg": [
		22941,
		[
			73991
		]
	],
	"./tournaments.svg": [
		91208,
		[
			73991
		]
	],
	"./tribal-white.svg": [
		25324,
		[
			73991
		]
	],
	"./up-for-8.svg": [
		36654,
		[
			73991
		]
	],
	"./upload-documents.svg": [
		69094,
		[
			73991
		]
	],
	"./user-VI.svg": [
		47389,
		[
			73991
		]
	],
	"./user-default-icon.svg": [
		51793,
		[
			73991
		]
	],
	"./user-details.svg": [
		53824,
		[
			73991
		]
	],
	"./user-icon-pre-login-default.svg": [
		15845,
		[
			73991
		]
	],
	"./user.svg": [
		62777,
		[
			73991
		]
	],
	"./vi-cross-sell-casino-mobile.svg": [
		59878,
		[
			73991
		]
	],
	"./vi-cross-sell-poker-mobile.svg": [
		81316,
		[
			73991
		]
	],
	"./vi-logo.svg": [
		98785,
		[
			73991
		]
	],
	"./vip-avatar-gold-VI.svg": [
		33810,
		[
			73991
		]
	],
	"./virtual-sports.svg": [
		82463,
		[
			73991
		]
	],
	"./wallet.svg": [
		5799,
		[
			73991
		]
	],
	"./winloss-history.svg": [
		66492,
		[
			73991
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13254;
module.exports = webpackAsyncContext;